import * as React from "react"

function IconCheck(props) {
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M3 8l3 3 7-7" stroke="#fff" />
        </svg>
    )
}

export default IconCheck
